import { render } from "./chart_kibot_zone.vue?vue&type=template&id=d634afe0&scoped=true"
const script = {}

import "./chart_kibot_zone.vue?vue&type=style&index=0&id=d634afe0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d634afe0"]])

export default __exports__